import { useLayoutEffect } from 'react'

/**
 * Remove the Progressier "Powered by" pill.
 * 1) Find any element whose text includes "Powered by"
 * 2) Walk up to the nearest fixed-position ancestor (the pill container)
 * 3) Remove that container so nothing remains on screen
 */
export function useHideProgressier() {
  useLayoutEffect(() => {
    const findBadge = (): HTMLElement | null => {
      const nodes = document.querySelectorAll<HTMLElement>('div, a, span')
      for (const el of nodes) {
        if (/powered by/i.test(el.textContent ?? '')) return el
      }
      return null
    }

    const getFixedAncestor = (el: HTMLElement | null): HTMLElement | null => {
      let node: HTMLElement | null = el
      let fixed: HTMLElement | null = null
      while (node && node !== document.body) {
        if (getComputedStyle(node).position === 'fixed') fixed = node
        node = node.parentElement
      }
      return fixed ?? el
    }

    const removeBadge = (): boolean => {
      const badge = findBadge()
      if (!badge) return false
      getFixedAncestor(badge)?.remove()
      return true
    }

    // Try immediately; if not found, watch the DOM until it appears.
    if (removeBadge()) return

    const observer = new MutationObserver(() => {
      if (removeBadge()) observer.disconnect()
    })
    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])
}
